
import { Component, Vue } from 'nuxt-property-decorator'

@Component({ name: 'FacebookBrands' })
export default class FacebookBrands extends Vue {}
